import { useEffect } from 'react'
import { useAppDispatch } from 'state/store'
import { interactionModelOperations } from '../redux'
import { InteractionModel } from 'types/shared'
import useInteraction from './useInteraction'

interface UseDraftInteractionParams {
  interactionUuid: string
  interactionModelUuid?: string
}

const useDraftInteraction = ({
  interactionUuid,
  interactionModelUuid
}: UseDraftInteractionParams) => {
  const dispatch = useAppDispatch()
  const { yesObject: draftInteraction, isFetched } = useInteraction({
    interactionUuid
  })

  useEffect(() => {
    if (
      draftInteraction &&
      interactionModelUuid &&
      draftInteraction?.uuid_interaction_model === interactionModelUuid
    ) {
      try {
        const parsedState = JSON.parse(
          draftInteraction.state || 'null'
        ) as InteractionModel | null

        if (!parsedState) return

        dispatch(
          interactionModelOperations.setStateFromDraft(
            parsedState,
            draftInteraction.version
          )
        )
      } catch (error) {
        console.error('Failed to parse draft interaction state:', error)
      }
    }
  }, [draftInteraction, interactionModelUuid, dispatch])

  return {
    draftInteraction,
    isFetched
  }
}

export default useDraftInteraction
